<script setup>
import { defineOptions, ref, reactive, watch, onMounted } from 'vue';

defineOptions({
  name: 'BsModal'
});

const props = defineProps(
  {
    id: String,
    open: {
      type: Boolean,
      default: false
    },
    size: String,
    scrollable: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    title: String,
    backdrop: {
      type: [String, Boolean],
      default: true
    },
    contentClassName: String
  }
);

const emits = defineEmits([
  'show',
  'shown',
  'hide',
  'hidden'
]);

const modal = ref(null);
const state = reactive({
  idName: props.id || 'modal-' + u.uid(),
  visible: props.open,
});

onMounted(() => {
  modal.value.addEventListener('show.bs.modal', (e) => {
    emits('show', e);
  });

  modal.value.addEventListener('shown.bs.modal', (e) => {
    emits('shown', e);
  });
  modal.value.addEventListener('hide.bs.modal', (e) => {
    emits('hide', e);
  });

  modal.value.addEventListener('hidden.bs.modal', (e) => {
    emits('hidden', e);
  });
});

watch(() => state.visible, (v, oldV) => {
  if (!oldV && v) {
    getModalInstance().show();
  }
  if (oldV && !v) {
    getModalInstance().hide();
  }
});

watch(() => props.open, (v) => {
  state.visible = v;
});

watch(() => props.id, (idName) => {
  state.idName = idName;
});

function getModalInstance() {
  const v = bootstrap.Modal.VERSION.split('.').shift();

  if (v >= 5) {
    return bootstrap.Modal.getOrCreateInstance(modal.value);
  } else {
    return bootstrap.Modal.getInstance(modal.value);
  }
}

const slots = defineSlots();

function hasSlots(name) {
  return slots[name] !== undefined;
}

</script>

<template>
  <div ref="modal" class="modal fade c-modal" :id="state.idName"
    v-bind="$attrs"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="state.idName + '-label'"
    :aria-hidden="state.visible ? 'true' : 'false'"
    :data-bs-backdrop="backdrop"
  >
    <div class="modal-dialog"
      role="document"
      :class="[size ? 'modal-' + size : null, {'modal-dialog-scrollable': scrollable}, {'modal-dialog-centered': centered}]">
      <div class="modal-content c-modal__content">

        <!-- Header -->
        <template v-if="state.visible">
          <template v-if="hasSlots('header-element')">
            <slot name="header-element"></slot>
          </template>
          <div v-else class="modal-header c-modal__header">
            <slot name="header">
              <div class="modal-title" :id="state.idName + '-label'">
                <h4>{{ title }}</h4>
              </div>
            </slot>
            <button type="button" class="close btn-close" data-bs-dismiss="modal" data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
          </div>
        </template>

        <!-- Body -->
        <div v-if="state.visible" class="modal-body c-modal__body">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div v-if="state.visible && hasSlots('footer')" class="modal-footer c-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
